import classes from "./FormEducation.module.css";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";
import { useTranslation } from "react-i18next";
import { SyntheticEvent } from "react";
import openFile from "../../../scripts/openFile";

interface Props {
  formSubmitHandler?: (
    e: React.SyntheticEvent<HTMLFormElement>,
    step: string
  ) => void;
  setLoading?: (val: boolean) => void;
}

const FormEducationComplete = ({ formSubmitHandler, setLoading }: Props) => {
  // Set translation
  const { t } = useTranslation();

  const { currentData } = useCurrentDataContext();

  const renderEducationAttachments = () => {
    // Filter records to get list of education and study type attachments
    const attachments =
      currentData?.records &&
      currentData?.records?.filter(
        (record) => record.type === "education" || record.type === "study"
      );

    // Render attachment items, showing name of each attachment
    return attachments && attachments?.length > 0
      ? attachments.map((rec, i) => (
          <div
            key={i}
            className={classes.recItemName}
            onClick={() => openFile(rec.file)}
          >
            {rec.title}
          </div>
        ))
      : t("formEducation.noAttachments");
  };

  const handleSubmit = () => {
    setLoading && setLoading(true);
    // Call for form submitHandler, which updates data to database
    formSubmitHandler &&
      formSubmitHandler(
        undefined as unknown as SyntheticEvent<HTMLFormElement>,
        "education"
      );
  };

  return (
    <div className={classes.formEducationContainer}>
      <div className={classes.formEducationEditRow}>
        <div className={classes.formEducationTitle}>
          {`1 ${t("formEducation.mainTitle")}`}
        </div>
        {currentData?.formStatus !== "waiting" && ( // Not rendered in doctor view
          <button
            className={classes.formEducationEditButton}
            onClick={() => {
              handleSubmit();
            }}
          >
            {t("formEducation.editButton")}
          </button>
        )}
      </div>

      <div className={classes.formEducationInnerContainerComplete}>
        <div>{t("formEducation.applicantEducationStatus")}</div>

        <div className={classes.formEducationCompleteAnswer}>
          {currentData?.educationLevel}
        </div>

        <div>{t("formEducation.terhikkiNumber")}</div>

        <div className={classes.formEducationCompleteAnswer}>
          {currentData?.registerNumber ||
            t("formEducation.applicantDoesntHaveTerhikkiNumber")}
        </div>

        <div>{t("formEducation.attachmentsTitle")}</div>

        <div className={classes.formEducationCompleteAnswer}>
          {renderEducationAttachments()}
        </div>
      </div>
    </div>
  );
};

export default FormEducationComplete;
